import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Skeleton, Tooltip } from '@mui/material';
import { CodeOutlined } from '@mui/icons-material';
import {
  DianaFeaturesEnum,
  AdvancedEditorMode,
  useHasFeature,
  useAdvancedEditorStore,
  usePerformanceReportBuilderPageStore,
} from '@diana/core';
import { StyledIconButton } from '../PerformanceReportBuilderPage.styles';
import { PERFORMANCE_REPORT_BUILDER_PAGE_NS } from '../i18n';
import { usePerformanceReportBuilderPageContext } from '../PerformanceReportBuilderPageContext';
import { FlowBuilderModalContentTypeEnum } from '../../FlowBuilder2Page/Store/FlowBuilder2PageStore.types';

export const AdvancedEditorButton = () => {
  const { t } = useTranslation(PERFORMANCE_REPORT_BUILDER_PAGE_NS);

  const { isLoading, error } = usePerformanceReportBuilderPageContext();

  const hasRawJsonAccess = useHasFeature(DianaFeaturesEnum.RawJson);

  const layout = usePerformanceReportBuilderPageStore((s) => s.layout);
  const setActiveModal = usePerformanceReportBuilderPageStore((s) => s.setActiveModal);
  const setEditorArgs = useAdvancedEditorStore((s) => s.setEditorArgs);

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  if (hasRawJsonAccess) {
    if (isLoading) return <Skeleton variant="circular" width={32} height={32} />;

    if (!error)
      return (
        <Tooltip title={t('tooltips.advancedEditor')} open={isTooltipOpen}>
          <StyledIconButton
            data-testid="AdvancedEditorButton"
            size="small"
            disabled={isLoading}
            onMouseEnter={() => setIsTooltipOpen(true)}
            onMouseLeave={() => setIsTooltipOpen(false)}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsTooltipOpen(false);
              if (layout) {
                setEditorArgs({ mode: AdvancedEditorMode.RawJson, nodeId: layout.id });
                setActiveModal(FlowBuilderModalContentTypeEnum.AdvancedEditor);
              }
            }}
          >
            {isLoading ? <CircularProgress size="1em" /> : <CodeOutlined fontSize="small" />}
          </StyledIconButton>
        </Tooltip>
      );
  }

  return <Fragment />;
};
